import { ButtonPropsVariantOverrides, Button } from '@mui/material';
import type { OverridableStringUnion } from '@mui/types';

export const FilterTableButton = (props: {
  setTableView: () => void;
  variant: OverridableStringUnion<'text' | 'outlined' | 'contained', ButtonPropsVariantOverrides>;
  text: string;
  disabled?: boolean;
}) => {
  return (
    <Button
      onClick={props.setTableView}
      variant={props.variant}
      color="primary"
      disabled={props.disabled}
    >
      {props.text}
    </Button>
  );
};
